export default __webpack_public_path__ + "static/media/photo--lg--23.8375f6b9.jpg";